import React, { useRef } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";


import karachi from "../../img/karachi.jpg";
import islamabad from "../../img/Faisal-Masjid.jpg";
import lahore from "../../img/lahore.png";
import murree from "../../img/Murree-Pakistan.png";
import hunza from "../../img/passu-valley-hunza-valley.jpg";
import skardu from "../../img/skardu.jpg";


import "./PopularDestinations.css";
const destinations = [
  { name: "Karachi", image: karachi, accommodations: "3,254 accommodations" },
  { name: "Islamabad", image: islamabad, accommodations: "2,143 accommodations" },
  { name: "Lahore", image: lahore, accommodations: "2,879 accommodations" },
  { name: "Murree", image: murree, accommodations: "1,120 accommodations" },
  { name: "Hunza", image: hunza, accommodations: "934 accommodations" },
  { name: "Skardu", image: skardu, accommodations: "512 accommodations" },
];



const PopularDestinations = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (direction === "left") {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    } else {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <div className="destinations-container">
      <h2 className="destinations-title">
        Popular destinations outside Pakistan
      </h2>

      <div className="scroll-wrapper">
        <button className="scroll-btn left" onClick={() => scroll("left")}>
          <FaChevronLeft size={24} />
        </button>

        <div className="destinations-scroll" ref={scrollRef}>
          {destinations.map((item, index) => (
            <div className="destination-card" key={index}>
              <img src={item.image} alt={item.name} />
              <h3>{item.name}</h3>
              <p>{item.accommodations}</p>
            </div>
          ))}
        </div>

        <button className="scroll-btn right" onClick={() => scroll("right")}>
          <FaChevronRight size={24} />
        </button>
      </div>
    </div>
  );
};

export default PopularDestinations;
